import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  setState
} from "../analyzeSlice";
import InfiniteScroll from "react-infinite-scroller";
import {
  Backdrop,
  CircularProgress
} from "@mui/material";

const MultiSelectRecords = (props) => {
  const dispatch = useDispatch();
  const RecordData = props?.Records;
  const Name = props?.name;
  const Records = RecordData?.map((item) => item.RecordName);
  const [RecordName, setRecordName] = useState([]);
  const [displayItem, setDisplayItem] = React.useState(RecordData.length - 1);
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState([]);
  const textInput = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const state = useSelector((store) => store.analyze);
  const loginState = useSelector((store) => store.login);
  const itemsPerPage = 200;
  const [hasMore, setHasMore] = useState(true);
  const [records, setrecords] = useState(itemsPerPage);
  const [recordsName, setrecordsName] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const {
    selectedRecords,
    clearIVDValues,
    clearMoleculeData,
    clearProductData,
    clearHQScenarioData,
    clearDataSourceData,
    clearIndividualCountryData
  } = state;
  const { globalSelectedCountryName, globalSelectedCountryID } = loginState;

  const loadMore = () => {
    if (records === RecordData.length) {
      setHasMore(false);
    } else {
      setTimeout(() => {
        setrecords(records + itemsPerPage);
      }, 2000);
    }
  };
  useEffect(() => {
    let item = [...namesData];
    item = item.filter((name) => !RecordName.includes(name));
    if (item.length == 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [namesData]);

  useEffect(() => {
    if (globalSelectedCountryName !== null && Name === "Sales Org") {
      let country = Records.filter((item) => item === globalSelectedCountryName);
      dispatch(setState("countrySelected", country));
      setRecordName(country);
      dispatch(setState("clearMoleculeData", true));
      dispatch(setState("clearProductData", true));
      dispatch(setState("clearHQScenarioData", true));
      dispatch(setState("clearDataSourceData", true));
      dispatch(setState("HQReportData", []));
    }
  }, [globalSelectedCountryName]);

  const handleChange = (e, name) => {
    let items = [...RecordName];

    if (e.target.checked) items.push(name);
    else {
      var index = items.indexOf(name);
      items.splice(index, 1);
    }

    setRecordName(items);

    let itemcount = items.length;
    setDisplayItem(itemcount);
    if (itemcount == 0) {
      setSelectAll(false);
      //dispatch(setState("allRecordsSelected", false));
    }
    if (itemcount == Records.length) {
      setSelectAll(true);
      //dispatch(setState("allRecordsSelected", true));
    }
    else {
      setSelectAll(false);
      //dispatch(setState("allRecordsSelected", false));
    }
    handleFetch(items);
  };

  const handleFetch = (items) => {
    if (Name === "Sales Org") {
      dispatch(setState("countrySelected", items));
      dispatch(setState("clearMoleculeData", true));
      dispatch(setState("clearProductData", true));
      dispatch(setState("clearHQScenarioData", true));
      dispatch(setState("clearDataSourceData", true));
      dispatch(setState("clearIndividualCountryData", true));
    } else if (Name === "Country") {
      dispatch(setState("individualCountrySelected", items));
    } else if (Name === "Molecule") {
      dispatch(setState("clearProductData", true));
      dispatch(setState("clearHQScenarioData", true));
      dispatch(setState("clearDataSourceData", true));
      dispatch(setState("moleculeSelected", items));
    } else if (Name === "Scenario") {
      dispatch(setState("clearProductData", true));
      dispatch(setState("clearDataSourceData", true));
      dispatch(setState("scenarioSelected", items));
      //dispatch(GetProductForScenario(ids));
    } else if (Name === "Product") {
      dispatch(setState("productSelected", items));
    } else if (Name === "DataSource") {
      dispatch(setState("dataSourceSelected", items));
    }
    dispatch(setState("HQReportData", []));
  }

  useEffect(() => {
    // Clear search text value
    setNamesData(Records);
  }, [RecordData]);

  // const handleDelete = (e, value) => {
  //   e.preventDefault();
  //   setSelectAll(false);
  //   setRecordName(RecordName.filter((name) => name !== value));
  // };
  const handleDelete = (e) => {
    e.preventDefault();
    setRecordName([]);
    handleFetch([]);
    setSelectAll(false);

  };

  useEffect(() => {
    if ((clearMoleculeData === true && Name === "Molecule" || (clearProductData === true && Name === "Product")
      || (clearHQScenarioData === true && Name === "Scenario") || (clearDataSourceData === true && Name === "DataSource") ||
      (clearIndividualCountryData === true && Name === "Country"))) {
      setRecordName([]);
      setSelectAll(false);
    }
    if (clearIndividualCountryData === true && Name === "Country") {
      dispatch(setState("individualCountrySelected", []));
      dispatch(setState("clearIndividualCountryData", false));
    }
    else if (clearMoleculeData === true && Name === "Molecule") {
      dispatch(setState("moleculeSelected", []));
      dispatch(setState("clearMoleculeData", false));
    } else if (clearProductData === true && Name === "Product") {
      dispatch(setState("productSelected", []));
      dispatch(setState("clearProductData", false));
    } else if (clearHQScenarioData === true && Name === "Scenario") {
      dispatch(setState("scenarioSelected", []));
      dispatch(setState("clearHQScenarioData", false));
    } else if (clearDataSourceData === true && Name === "DataSource") {
      dispatch(setState("dataSourceSelected", []));
      dispatch(setState("clearDataSourceData", false));
    }
  }, [clearMoleculeData, clearProductData, clearHQScenarioData, clearDataSourceData])

  const handleInputChange = (value) => {
    setSearchText(value);
  };



  const handleSelectAll = () => {
    if (Records.length > 100) {
      setIsLoading(true);
    }
    setSelectAll(!selectAll);
    const timer = setTimeout(() => {
      const isselectAll = !selectAll;
      if (!selectAll) {
        if (searchText) {
          let val = Records.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
          let item = [...RecordName, ...val];
          const distinctArray = [...new Set(item)];
          setRecordName(distinctArray);
          handleFetch(distinctArray);
          let itemcount = distinctArray.length - 1;
          setDisplayItem(itemcount);
        } else {
          setRecordName(Records);
          handleFetch(Records);
          let itemcount = Records.length - 1;
          setDisplayItem(itemcount);
          //dispatch(setState("allRecordsSelected", true));
        }
      } else {
        if (searchText) {
          let val = Records.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
          let item = [...RecordName];
          item = item.filter((name) => !val.includes(name));
          const distinctArray = [...new Set(item)];
          setRecordName(distinctArray);
          handleFetch(distinctArray);
          let itemcount = distinctArray.length;
          setDisplayItem(itemcount);
        } else {
          setRecordName([]);
          handleFetch([]);
          let itemcount = 0;
          setDisplayItem(itemcount);
        }
      }
    }, 10);
    return () => clearTimeout(timer);
  };


  useEffect(() => {
    let itemcount = selectedOptions.length - 1;
    setDisplayItem(itemcount);
  }, [selectedOptions])


  useEffect(() => {

    let itemcount = RecordName.length - 1;
    setDisplayItem(itemcount);
  }, [RecordName])

  useEffect(() => {

    const delayDebounceFn = setTimeout(() => {
      if (searchText) {

        setNamesData((prevVal) => {
          let val = Records.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));

          return val;
        });
      } else {
        setSearchText();
        setNamesData(Records);
      }


      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  const getRecordIdsFromNames = (RecordNames) => {
    const RecordIds = RecordNames.map((name) => {
      const Record = RecordData.find((option) => option.RecordName === name);
      return Record ? Record.RecordID : null;
    });
    return RecordIds.filter((id) => id !== null);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      // if (RecordName.length > 0) {
      //   dispatch(setState("selectedDataRecordIds", getRecordIdsFromNames(RecordName)));
      //   dispatch(setState("clearIVDValues", false));
      // }
      // else {
      //   dispatch(setState("selectedDataRecordIds", []))
      // }
      // setrecordsName(RecordName.slice(0, 1));
      dispatch(setState("RecordIVDList", RecordName));
      if (RecordName.length > 0) {
        dispatch(setState("clearIVDValues", false));
      }
      setIsLoading(false)
    }, 500);
    return () => clearTimeout(timeout);
  }, [RecordName])

  useEffect(() => {
    if (clearIVDValues) {
      setRecordName([]);
      handleFetch([]);
      setSelectAll(false);
      setSearchText("");
    }
  }, [clearIVDValues])

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress style={{ position: 'absolute', zIndex: 1300 }} />
      </Backdrop>
      <InfiniteScroll
        pageStart={0}
        loadMore={loadMore}
        hasMore={hasMore}
        useWindow={false}
      >
        <FormControl>
          <InputLabel>{Name}</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            //fullWidth
            sx={{
              width: "240px !important",
              height: "44px !important",
            }}
            MenuProps={{
              style: {
                zIndex: 1200 // Set this value lower than the spinner's z-index
              }
            }}
            value={RecordName}
            //onChange={handleChange}
            size="small"
            input={<OutlinedInput label="MultiSelect" />}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }} MenuProps>
                <div>
                  {RecordName.length === 1 && (
                    <span>{RecordName[0]?.substring(0, 12)}</span>
                  )}
                  {RecordName.length > 1 && (
                    <span>{RecordName[0]?.substring(0, 12)}  + <b>{displayItem}</b></span>
                  )}
                  <span>
                    <CancelIcon
                      sx={{
                        paddingLeft: "25px",
                        top: "20%",
                        position: "absolute",
                      }}
                      onMouseDown={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}


                      onClick={(e) => handleDelete(e)}
                    />
                  </span>


                </div>

              </Box>
            )}
          >
            <MenuItem onClick={handleSelectAll}>
              <Checkbox checked={selectAll} />
              <ListItemText primary="Select All" />
            </MenuItem>
            <ListSubheader>
              <TextField
                size="small"
                inputRef={textInput}
                placeholder=""
                //fullWidth
                value={searchText}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    /*close icon to clear the search text*/
                    <InputAdornment position="end">
                      <IconButton onClick={() => setSearchText("")}>
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleInputChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>
            {namesData?.slice(0, 100)?.map((name, index) => (
              <MenuItem key={index + name} value={name}>
                {selectAll ? <Checkbox onChange={(e) => handleChange(e, name)}
                  checked={RecordName.some((o) => o === name)}
                /> :
                  <Checkbox onChange={(e) => handleChange(e, name)} checked={RecordName.indexOf(name) > -1} />}
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </InfiniteScroll>
    </div>

  )
}

export default MultiSelectRecords